import React, { useEffect, useRef, useState } from "react";
import { axiosFunction } from "../../../../components/commonFunctions/axiosFunction"
import { useParams } from "react-router-dom";
import { v2ReactURL } from "../../../../utils/constant";
import { CustomDataTable, PageOptions } from "../../../../components/common";
import { DateFormat, DateTimeFormat } from "../../../../utils/DateFormat";

import { ContactDetailsDataTableContainer } from "./ContactDetailsDataTableContainer";

import { FaRegEdit, FaRegFilePdf } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { SwalFunction } from "../../../../components/commonFunctions/SwalFunction";
import { useSelector } from "react-redux";
import { dataTableMetaDTOSchema, Pagination } from "../../MainDataTable";
import { z } from 'zod';
import { SelectChangeEvent } from "@mui/material";
import { Column } from "../../../../components/common/CustomDataTable/CustomDataTable";
import { productSchemaType } from "../ContactDetails";
import { toastMessage } from "../../../../components/commonFunctions/ToasterMessage";
import { MdDelete } from "react-icons/md";
import CustomButton from "../../../../components/common/CustomButton/CustomButton";
import ProductSearchTypeHead from "../ProductList/ProductSearchTypeHead";
const GenericDataItemSchema = z.object({
  branch_name: z.string(),
  branchid: z.number(),
  childtype: z.number(),
  comment: z.string(),
  created_by: z.string(),
  firstname: z.string(),
  invocicenumber: z.string(),
  lastname: z.string(),
  mobno: z.string(),
  paidamount: z.number(),
  partiallystatus: z.any().nullable(),
  paymentstatus: z.string(),
  rating: z.any().nullable(),
  recomended: z.string(),
  salesdate: z.string(),
  salesid: z.number(),
  status: z.string().nullable(),
  submitdate: z.string(),
  total: z.number(),
  type: z.string(),
})

export const GenericDataSchema = z.object({
  data: z.array(GenericDataItemSchema),
  dataTableMetaDTO: dataTableMetaDTOSchema,
  recordsFiltered: z.number(),
  recordsTotal: z.number(),
  draw: z.number(),
  error: z.nullable(z.string()).optional(),
});

export interface Params {
  row: GenericDataItemType & { index?: number };
}

export type GenericDataItemType = z.infer<typeof GenericDataItemSchema>;

const ReciptDataItemSchema = z.object({
  acceptedBankReceipt: z.number(),
  bankId: z.number(),
  branchId: z.number(),
  contactName: z.string(),
  contactType: z.string(),
  createdOn: z.string().nullable(),
  createdbyname: z.string(),
  partyAccountId: z.number(),
  paymentType: z.string().nullable(),
  receiptDate: z.string(),
  receiptId: z.number(),
  receiptMode: z.string(),
  receiptNo: z.string(),
  status: z.string(),
  totalPayment: z.number(),
  type: z.string()
});
type ReciptDataItemType = z.infer<typeof ReciptDataItemSchema>;

const PaymentDataItemSchema = z.object({
  acceptedBankReceipt: z.number(),
  accountName: z.string(),
  bankId: z.number(),
  bankTransactionType: z.string().nullable(),
  branchId: z.number(),
  cashAccountCustomId: z.number(),
  contactName: z.string(),
  contactType: z.string(),
  createdOn: z.string().nullable(),
  createdbyname: z.string(),
  partyAccountId: z.number(),
  paymentDate: z.string(),
  paymentId: z.number(),
  paymentMode: z.string(),
  paymentNo: z.string(),
  status: z.string(),
  totalPayment: z.number(),
  type: z.string(),
});
type PaymentDataItemType = z.infer<typeof PaymentDataItemSchema>;


interface PaymentParams {
  row: PaymentDataItemType & { index?: number };
}
interface ReciptParams {
  row: ReciptDataItemType & { index?: number };
}
interface InvoiceDataTableProps {
  tabView: string;
  productData?: productSchemaType;
  loyaltyPoint?: number;
  openImportDialog?:boolean;
}
export interface ProductListDataTableProps {
  productData: productSchemaType;
}
const ProductListDataItemSchema = z.object({
  contactProductId: z.number(),
  landingCost: z.number(),
  name: z.string(),
  price: z.number(),
  productId: z.number(),
  productVarientId: z.number(),
});
type ProductListDataItemType = z.infer<typeof ProductListDataItemSchema>;
const ProductListDataTableSchema = GenericDataSchema.extend({
  data: z.array(ProductListDataItemSchema),
})

interface ProductListParams {
  row: ProductListDataItemType & { index?: number };
}

interface updatedPriceType {
  [key: number]: string;
}
const LoyaltyDataItemSchema = z.object({
  billNo: z.string(),
  createdOn: z.string(),
  description: z.string(),
  inPoints: z.number(),
  outPoints: z.number(),
  pointTransactionId: z.number()
});
type LoyaltyDataItemType = z.infer<typeof LoyaltyDataItemSchema>;

interface LoyaltyParams {
  row: LoyaltyDataItemType & { index?: number };
}
const ExpenseDataItemSchema = z.object({
  account_name: z.string(),
  branch: z.string(),
  branch_id: z.number(),
  createdby: z.string(),
  expense_date: z.string(),
  expense_id: z.number(),
  expense_no: z.string(),
  invoice_number: z.string().nullable(),
  is_created_on_pos: z.number(),
  paid_amount: z.number(),
  status: z.string(),
  tds_amount: z.number(),
  tds_applicable: z.number(),
  total: z.number()
});
type ExpenseDataItemType = z.infer<typeof ExpenseDataItemSchema>;


interface ExpenseParams {
  row: ExpenseDataItemType & { index?: number };
}
const SupplierBillDataItemSchema = z.object({
  billno: z.string(),
  createdby: z.string(),
  dueamount: z.number(),
  paidamount: z.number(),
  purchasedate: z.string(),
  purchaseid: z.number(),
  total: z.number(),
  branchid: z.number().optional().nullable(),
  tds_applicable: z.number().optional().nullable(),
  tds_amount: z.number().optional().nullable(),
  status : z.string().optional().nullable(),
});
type SupplierBillDataItemType = z.infer<typeof SupplierBillDataItemSchema>;


interface SupplierBillParams {
  row: SupplierBillDataItemType & { index?: number };
}
const DebitNoteDataItemSchema = z.object({
  billno: z.string(),
  createdby: z.string(),
  dueamount: z.number(),
  paidamount: z.number(),
  purchasedate: z.string(),
  purchaseid: z.number(),
  total: z.number(),
  branchid: z.number().optional().nullable(),
});
type DebitNoteDataItemType = z.infer<typeof DebitNoteDataItemSchema>;
//  const DebitNoteDataTableSchema =  GenericDataSchema.extend({
//  data: z.array(DebitNoteDataItemSchema),
//  })

interface DebitNoteParams {
  row: DebitNoteDataItemType & { index?: number };
}

const DataTableMetaDTO = z.object({
  page: z.number(),
  pages: z.number(),
  perpage: z.number(),
  total: z.number(),
});


type DataTableMetaDTO = z.infer<typeof DataTableMetaDTO>;

const GenericDataSchemas = z.object({
  dataTableMetaDTO: DataTableMetaDTO,
  recordsFiltered: z.number(),
  recordsTotal: z.number(),
  draw: z.number(),
  error: z.string().nullable().optional(),
  data: z.array(z.any()),
});






const ContactDetailsDataTable: React.FC<InvoiceDataTableProps> = ({ tabView, productData ,loyaltyPoint , openImportDialog = false}) => {
  const params = useParams();
  const isFirstRun = useRef(true);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const decimalPoints = sessionList?.decimalPoint || 2;
  const sessionData = useSelector((state: any) => state.sessionData);
  const [columns, setColumns] = useState<Column[]>([]);
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [updatedPrice, setUpdatedPrice] = useState<updatedPriceType>({});
  const [paginationInfo, setPaginationInfo] = useState<Pagination>({
    page: 0,
    pages: 0,
    perpage: 0,
    total: 0,
  });

  const [pageOption, setPageOption] = useState<string>("15");
  const AccountCustomId = useSelector(
    (state: any) =>
      state.contactGeneralDetails?.ContactDetails?.accountCustomId
  );

  const customerMobNo = useSelector(
    (state: any) => state.contactGeneralDetails?.ContactDetails?.mobNo
  );

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
  
    fetchProductListDatatable(0, 15);
  }, [openImportDialog]);

  const fetchInvoiceDatatable = async (startIndex: number, pageLength: number) => {
    setLoadingData(true);

    // Handle the case where customer mobile number is not provided
    if (tabView === "customerLoyaltyLedger" && !customerMobNo) {
      toastMessage("Customer's Mobile Number Is Not Provided");
      setLoadingData(false);
      return; // Exit early
    }
    let dynamicTabView = "";
    switch (tabView) {
      case "invoice":
        dynamicTabView = `/sales/invoice/${params.contactId}/datatableCutomerWise`;
        break;
      case "creditNote":
        dynamicTabView = `/sales/creditnote/${params.contactId}/datatableCutomerWise`;
        break;
      case "receipt":
        dynamicTabView = `/receipt/${params.contactType}/customdatatablereciept`;
        break;
      case "payment":
        dynamicTabView = `/payment/${AccountCustomId}/customdatatableforpayment`;
        break;
      case "productList":
        dynamicTabView = `/contact/customdatatable/${params.contactId}/customerspecificprice`;
        break;
      case "customerLoyaltyLedger":
        dynamicTabView = `/contact/loyaltypoints/transactions/${customerMobNo}`;
        break;
      case "expense":
        dynamicTabView = `/expense/datatable`;
        break;
      case "supplierBill":
        dynamicTabView = `/purchase/bill/${params.contactId}/contact/datatable`;
        break;
      case "debitNote":
        dynamicTabView = `/purchase/debitnote/${params.contactId}/contact/datatable`;
        break;
      default:
        dynamicTabView = "/sales/unknown/";
    }

    try {
      const res = await axiosFunction(
        `${v2ReactURL}${dynamicTabView}`,
        "POST",
        {
          searchValue: "",
          length: pageLength,
          start: startIndex,
          draw: 1,
          branchIds: [sessionData.sessionScope.branchId],
          accountCustomId: AccountCustomId,
        }
      );
      const validatedData = GenericDataSchemas.safeParse(res?.data?.response);

      if (validatedData.success) {
        const dataList = validatedData.data.data.map((col, index: number) => ({
          ...col,
          index: index + 1,
        }));

        setPaginationInfo(validatedData.data.dataTableMetaDTO);
        setInvoiceData(dataList);
      } else {
        console.error("API response validation failed:", validatedData.error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleDeleteExpense = async (params: ExpenseParams) => {
    const paymentStatusRes = await axiosFunction(
      `${v2ReactURL}/payment/${params.row.expense_id}/expense/checkPaymentStatus`,
      "GET"
    );
    if (paymentStatusRes.data.response === "0") {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const res = await axiosFunction(
          `${v2ReactURL}/expense/${params.row.expense_id}/delete`,
          "DELETE"
        );

        if (res.data.status) {
          fetchInvoiceDatatable(0, 15);;
        }
      }
    }
  };

  const handleDeleteDebitNote = async (id: number) => {
    const debitNoteAvailStatusRes = await axiosFunction(
      `${v2ReactURL}/purchase/${id}/getDebitNoteAvailabiltyStatus`,
      "GET"
    );
    if (debitNoteAvailStatusRes.data.response === "0") {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const res = await axiosFunction(
          `${v2ReactURL}/purchase/debitnote/${id}/delete`,
          "DELETE"
        );

        if (res.data.status) {
          fetchInvoiceDatatable(0, 15);
        }
      }
    }
  };

  const handlePDFPreviewOfDebitNote = async (purhaseId: number) => {
    const res = await axiosFunction(
      `${v2ReactURL}/purchase/debitnote/${purhaseId}/pdf`,
      "GET",
      null,
      false,
      "blob"
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", "debitnote.pdf");

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };
  const handleDeleteSpecificPrice = async (row: ProductListParams["row"]) => {
    const result = await SwalFunction(
      "Are You Sure?",
      "You Won't Be Able To Revert This!",
      "Yes, Delete It!",
      { icon: "warning" }
    );
    if (result.isConfirmed) {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/${row.contactProductId}/deletecustomerspecificprice?productId=${row.productId}`,
        "DELETE"
      );

      if (res?.data?.status) {
        toastMessage(res?.data?.response, "success");
        fetchInvoiceDatatable(0, 15);
      }
    }
  };
  const handleDeleteInvoice = async (params: Params) => {
    const receiptStatusRes = await axiosFunction(
      `${v2ReactURL}/sales/${params.row.salesid}/checkReceiptStatus`,
      "GET"
    );

    const creditNoteStatusRes = await axiosFunction(
      `${v2ReactURL}/sales/${params.row.salesid}/getCreditNoteStatus`,
      "GET"
    );

    if (
      receiptStatusRes.data.response === "0" &&
      creditNoteStatusRes.data.response === "0"
    ) {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const res = await axiosFunction(
          `${v2ReactURL}/sales/invoice/${params.row.salesid}/delete`,
          "DELETE"
        );

        if (res.data.status) {
          fetchInvoiceDatatable(0, 15)
        }
      }
    } else {
      creditNoteStatusRes.data.response === "1" && toastMessage("The credit note is generated against this bill, please delete that to delete this bill.", "error");
    }
  };

  const handlePDFPreview = async (row: Params["row"]) => {

    const type = row.type;
    const invoiceWiseURL = 
    type === "invoice"
      ? `${v2ReactURL}/sales/${type}/pdf/${row.salesid}`
      : type === "creditnote"
      ? `${v2ReactURL}/sales/creditnote/pdf/${row.salesid}`
      : `${v2ReactURL}/${type}/pdf/${row.salesid}`;
  

    const res = await axiosFunction(invoiceWiseURL, "GET", null, false, "blob");

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", "invoice.pdf");

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };
  const handlePDFPreviewReceipt = async (receiptId: number) => {

    const res = await axiosFunction(
      `${v2ReactURL}/receipt/pdf/${receiptId}`,
      "GET",
      null,
      false,
      "blob"
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", "receipt.pdf");

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };

  const handlePDFPreviewOfSupplierBill = async (purhaseId: number) => {
    const res = await axiosFunction(
      `${v2ReactURL}/purchase/bill/${purhaseId}/pdf`,
      "GET",
      null,
      false,
      "blob"
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", "bill.pdf");

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };

  const handlePDFPreviewPayment = async (paymentId: number) => {
    const res = await axiosFunction(
      `${v2ReactURL}/payment/pdf/${paymentId}`,
      "GET",
      null,
      false,
      "blob"
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;

    // Set filename based on file type
    link.setAttribute("download", "payment.pdf");

    // Trigger download
    document.body.appendChild(link);
    link.click();
  };
  const handleDeleteReceipt = async (params: ReciptParams) => {
     
    const paymentStatusRes = await axiosFunction(
      `${v2ReactURL}/payment/${params.row.receiptId}/receipt/checkPaymentStatus`,
      "GET"
    );
    if (paymentStatusRes.data.response === "0") {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const response = await axiosFunction(
          `${v2ReactURL}/receipt/${params.row.receiptId}/delete`,
          "DELETE"
        );
        if(response.data.status){
        fetchInvoiceDatatable(0, 15);
        }
      }
    }
  };
  const handleDeleteCreditNote = async (row: Params["row"]) => {
    const creditNoteStatusRes = await axiosFunction(
      `${v2ReactURL}/sales/${row.salesid}/getCreditNoteAvailabiltyStatus`,
      "GET"
    );
    if (creditNoteStatusRes.data.response === "0") {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const res = await axiosFunction(
          `${v2ReactURL}/sales/creditnote/${row.salesid}/delete`,
          "DELETE"
        );

        if (res.data.status) {
          fetchInvoiceDatatable(0, 15);;
        }
      }
    }
  };

  const handleDeleteSupplierBill = async (id: number) => {
    const paymentStatusRes = await axiosFunction(
      `${v2ReactURL}/payment/${id}/bill/checkPaymentStatus`,
      "GET"
    );

    const debitNoteStatusRes = await axiosFunction(
      `${v2ReactURL}/purchase/${id}/getDebitNoteStatus`,
      "GET"
    );

    if (
      paymentStatusRes.data.response === "0" &&
      debitNoteStatusRes.data.response === "0"
    ) {
      const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        { icon: "warning" }
      );

      if (result.isConfirmed) {
        const res = await axiosFunction(
          `${v2ReactURL}/purchase/bill/${id}/delete`,
          "DELETE"
        );

        if (res.data.status) {
          fetchInvoiceDatatable(0, 15);;
        }
      }
    } else {
      debitNoteStatusRes.data.response === "1" &&  toastMessage("The Debit note is generated against this bill, please delete that to delete this bill.", "error");
    }
  };
  const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>, row: ProductListParams["row"]) => {
    const variantId = row.productVarientId;
    const newPrice = e.target.value;
    if (String(row.price) === newPrice) {
      return; // No change, skip update
    }

      setUpdatedPrice((prev) => ({
        ...prev,
        [variantId]: newPrice,
      }));
      setInvoiceData((prevRows) =>
        prevRows.map((r) =>
          r.productVarientId === variantId
            ? { ...r, price: newPrice } // ✅ convert to number here
            : r
        )
      );

  };

  // const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, _row: ProductListParams["row"]) => {
  //   const newPrice = (e.target as HTMLInputElement).value;

  //   if (e.key === "Enter") {
  //     if (!/^\d*$/.test(newPrice)) {
  //       toastMessage("enter only numeric value, this changes not be saved");
  //     }
  //   }
  // };
  useEffect(() => {
    // console.log("tabView", tabView);
    if (tabView === "invoice") {
      const invoiceColumns: Column[] = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: any) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "invocicenumber",
          headerName: "Invoice No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => params.row.invocicenumber,
        },
        {
          field: "salesdate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => DateFormat(params.row.salesdate),
        },
        {
          field: "total",
          headerName: "Total Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => (params.row.total)?.toFixed(decimalPoints),
        },
        {
          field: "paidamount",
          headerName: "Paid Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => (params.row.paidamount)?.toFixed(decimalPoints),
        },
        {
          field: "Documents Name",
          headerName: "Due Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => (params.row.total - params.row.paidamount)?.toFixed(decimalPoints),
        },
        {
          field: "comment",
          headerName: "Feedback",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => params.row.comment || "-",
        },
        {
          field: "branch_name",
          headerName: "Branch Name",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => params.row.branch_name,
        },
        {
          field: "created_by",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) => params.row.created_by,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: any) =>
            // console.log("params.row.branchid",params.row.branchid)
            // console.log("sessionList?.branchId",sessionList)
            params.row.branchid === sessionList?.branchId && (
              <div className="d-flex">
                <button
                  onClick={() => handlePDFPreview(params.row)}
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                >
                  <FaRegFilePdf size={16} />
                </button>
                {params.row.type === "invoice" &&
                  params.row.total - params.row.paidamount !== 0 &&
                  params.row.childtype === 0 &&
                  params.row.partiallystatus !== "Partially Cancelled" &&
                  params.row.status !== "Cancelled" && (
                    <>
                      {
                         (
                          <button
                          style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                            onClick={() =>
                              (window.location.href = `/sales/invoice/${params.row.salesid}/edit`)
                            }
                          >
                            <FaRegEdit size={16} />
                          </button>
                        )}
                      <button
                        style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                        onClick={() => handleDeleteInvoice(params)}
                      >
                        <RiDeleteBin5Line size={16} />
                      </button>
                    </>
                  )}
              </div>
            ),
        },
      ];
      setColumns(invoiceColumns);
    }
    if (tabView === "creditNote") {
      const creditNoteColumns: Column[] = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params) =>
            paginationInfo.page * paginationInfo.perpage + params.row.index,
        },
        {
          field: "invocicenumber",
          headerName: "Credit Note No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => params.row.invocicenumber,
        },
        {
          field: "salesdate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => DateFormat(params.row.salesdate),
        },
        {
          field: "total",
          headerName: "Total Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => params.row.total?.toFixed(decimalPoints),
        },
        {
          field: "paidamount",
          headerName: "Paid Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => params.row.paidamount?.toFixed(decimalPoints),
        },
        {
          field: "Documents Name",
          headerName: "Due Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => (params.row.total - params.row.paidamount)?.toFixed(decimalPoints),
        },

        {
          field: "created_by",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) => params.row.created_by,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params) =>
            params.row.branchid === sessionList?.branchId && (
              <>
                {params.row.type === "posreturn" ? (
                  <>
                    <button
                      onClick={() => handlePDFPreview(params.row)}
                      style={{
                        color: "#7a7979",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaRegFilePdf size={16} />
                    </button>

                    {params.row.paidamount === 0 && (
                      <>
                        <button
                          style={{
                            color: "#7a7979",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            (window.location.href = `/sales/creditnote/${params.row.salesid}/edit`)
                          }
                        >
                          <FaRegEdit size={16} />
                        </button>
                        <button
                          style={{
                            color: "#7a7979",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteCreditNote(params.row)}
                        >
                          <RiDeleteBin5Line size={16} />
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => handlePDFPreview(params.row)}
                      style={{
                        color: "#7a7979",
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaRegFilePdf size={16} />
                    </button>
                    {params.row.total - params.row.paidamount > 0 && (
                      <>
                        <button
                          style={{
                            color: "#7a7979",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            (window.location.href = `/sales/creditnote/${params.row.salesid}/edit`)
                          }
                        >
                          <FaRegEdit size={16} />
                        </button>
                        <button
                          style={{
                            color: "#7a7979",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteCreditNote(params.row)}
                        >
                          <RiDeleteBin5Line size={16} />
                        </button>
                      </>
                    )}
                  </>
                )}
              </>
            ),
        },
      ];
      setColumns(creditNoteColumns);
    }
    if (tabView === "receipt") {
      const receiptColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: ReciptParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "receiptNo",
          headerName: "Receipt No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) => (
            <a href={`/receipt/${params.row.receiptId}`}>
            {params.row.receiptNo}
          </a>
          ),
        },
        {
          field: "receiptDate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) => DateFormat(params.row.receiptDate),
        },
        {
          field: "receiptMode",
          headerName: "Payment Mode",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) => params.row.receiptMode,
        },
        {
          field: "totalPayment",
          headerName: "Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) => params.row.totalPayment?.toFixed(decimalPoints),
        },

        {
          field: "createdbyname",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) => params.row.createdbyname,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ReciptParams) =>
            params.row.branchId === sessionList?.branchId && (
              <div className="d-flex">
                <button
                  // className="btn btn-sm pdf-preview-btn"
                  onClick={() => handlePDFPreviewReceipt(params.row.receiptId)}
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                >
                  <FaRegFilePdf size={16} />
                </button>
                <button
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                  onClick={() =>
                    (window.location.href = `/receipt/${params.row.receiptId}/edit`)
                  }
                >
                  <FaRegEdit size={16} />
                </button>
                <button
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                  onClick={() => handleDeleteReceipt(params)}
                >
                  <RiDeleteBin5Line size={16} />
                </button>
              </div>
            ),
        },
      ];
      setColumns(receiptColumns);
    }
    if (tabView === "payment") {
      const paymentColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: PaymentParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "paymentNo",
          headerName: "Payment No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) =>(
            <a href={`/payment/${params.row.paymentId}`}>
            {params.row.paymentNo}
          </a>
          ) ,
        },
        {
          field: "paymentDate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) => DateFormat(params.row.paymentDate),
        },
        {
          field: "paymentMode",
          headerName: "Payment Mode",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) => params.row.paymentMode,
        },
        {
          field: "totalPayment",
          headerName: "Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) => params.row.totalPayment?.toFixed(decimalPoints),
        },

        {
          field: "createdbyname",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) => params.row.createdbyname,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: PaymentParams) =>
            params.row.branchId === sessionList?.branchId && (
              <div className="d-flex">
                <button
                  onClick={() => handlePDFPreviewPayment(params.row.paymentId)}
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                >
                  <FaRegFilePdf size={16} />
                </button>
              </div>
            ),
        },
      ];
      setColumns(paymentColumns);
    }
    if (tabView === "productList") {
      const productListColumns = [
        {
          field: "id",
          headerName: "Sr. No.",
          width: 50,
          defaultChecked: true,
          renderCell: (params: ProductListParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "productName",
          headerName: "Product Name",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ProductListParams) => params.row.name,
        },
        {
          field: "landingPrice",
          headerName: "Landing Price",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ProductListParams) => params.row.landingCost?.toFixed(decimalPoints),
        },
        {
          field: "customerSpecificPrice",
          headerName: "Customer Specific Price",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ProductListParams) => (
            <input
              type="text"
              className="form-control form-control-sm customInput"
              defaultValue={params.row.price}
              onBlur={(e) => handlePriceChange(e, params.row)}
              // onKeyDown={(e) => handleKeyPress(e, params.row)}
              // value={updatedPrice[params.row.productVarientId] ?? params.row.price}
            />
          ),
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ProductListParams) => (
            <div
              style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
              onClick={() => handleDeleteSpecificPrice(params.row)}
            >
              <MdDelete
                size={20}
                className="common__icon"
                style={{ color: "red" }}
              />
            </div>
          ),
        },
      ];
      setColumns(productListColumns);
    }
    if (tabView === "customerLoyaltyLedger") {
      // console.log("loyaltyPoint",paginationInfo.page,paginationInfo.perpage,)
      const customLoyaltyColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: LoyaltyParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "createdOn",
          headerName: "Created On",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: LoyaltyParams) => DateTimeFormat(params.row.createdOn),
        },
        {
          field: "billNo",
          headerName: "Bill No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: LoyaltyParams) => params.row.billNo,
        },
        {
          field: "inPoints",
          headerName: "In Point",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: LoyaltyParams) => params.row.inPoints?.toFixed(decimalPoints),
        },
        {
          field: "outPoints",
          headerName: "Out Point",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: LoyaltyParams) => params.row.outPoints?.toFixed(decimalPoints),
        },
        {
          field: "description ||  - ",
          headerName: "Description",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: LoyaltyParams) => params.row.description || "-",
        },
      ];
      setColumns(customLoyaltyColumns);
    }
    if (tabView === "expense") {
      const expenseColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: ExpenseParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "expense_no",
          headerName: "No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => (
            <a href={`/expense/${params.row.expense_id}`}>
            {params.row.expense_no}
          </a>
          ),
        },
        {
          field: "expense_date",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => DateFormat(params.row.expense_date),
        },
        {
          field: "account_name",
          headerName: "Party Name",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => params.row.account_name,
        },
        {
          field: "total",
          headerName: "Total",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => params.row.total?.toFixed(decimalPoints),
        },
        {
          field: "paid_amount",
          headerName: "Paid",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => params.row.paid_amount?.toFixed(decimalPoints),
        },
        {
          field: "unpaid",
          headerName: "UnPaid",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => (params.row.total - params.row.paid_amount)?.toFixed(decimalPoints),
        },
        {
          field: "branch",
          headerName: "Branch",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => params.row.branch,
        },

        {
          field: "createdby",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) => params.row.createdby,
        },
        {
          field: "created_by",
          headerName: "Created From",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) =>
            params.row.is_created_on_pos === 0 ? "Expense" : "POS",
        },
        {
          field: "action",
          headerName: "Actions",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: ExpenseParams) =>
            // params.row.branch_id === sessionList?.branchId && (
            <div className="d-flex">
              <button
                style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                onClick={() =>
                  (window.location.href = `/expense/${params.row.expense_id}/edit`)
                }
              >
                <FaRegEdit size={16} />
              </button>
              <button
                style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                onClick={() => handleDeleteExpense(params)}
              >
                <RiDeleteBin5Line size={16} />
              </button>
            </div>
          // ),
        },
      ];
      setColumns(expenseColumns);
    }
    if (tabView === "supplierBill") {
      const supplierBillColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: SupplierBillParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "billno",
          headerName: "Supplier Bill No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => ( 
          <a href={`/purchase/bill/${params.row.purchaseid}`}>
            {params.row.billno}
          </a>),
        },
        {
          field: "purchasedate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => DateFormat(params.row.purchasedate),
        },
        {
          field: "total",
          headerName: "Total Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => params.row.total?.toFixed(decimalPoints),
        },
        {
          field: "paidamount",
          headerName: "Paid Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => params.row.paidamount?.toFixed(decimalPoints),
        },
        {
          field: "dueamount",
          headerName: "Due Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => params.row.dueamount?.toFixed(decimalPoints),
        },
        {
          field: "createdby",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) => params.row.createdby,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: SupplierBillParams) =>
            // params.row.branchid === sessionList?.branchId && (
            <div className="d-flex">
              <button
                onClick={() => handlePDFPreviewOfSupplierBill(params.row.purchaseid)}
                style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
              >
                <FaRegFilePdf size={13} />
              </button>

              {(params.row.tds_applicable !== null || params.row.tds_applicable === 1 ? (params.row.paidamount - (params.row.tds_amount ?? 0)) <= 0 : params.row.paidamount<=0) && params.row.status !='paid' && (
                <>
                  <button
               style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                    onClick={() =>
                      (window.location.href = `/purchase/bill/${params.row.purchaseid}/edit`)
                    }
                  >
                    <FaRegEdit size={16} />
                  </button>
                  <button
                     style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                    onClick={() =>
                      handleDeleteSupplierBill(params.row.purchaseid)
                    }
                  >
                    <RiDeleteBin5Line size={16} />
                  </button>
                </>
              )}
            </div>
          // ),
        },
      ];
      setColumns(supplierBillColumns);
    }
    if (tabView === "debitNote") {
      const debitNoteColumns = [
        {
          field: "id",
          headerName: "#",
          width: 44,
          defaultChecked: true,
          renderCell: (params: DebitNoteParams) =>
            paginationInfo.page * paginationInfo.perpage + (params.row.index ?? 0),
        },
        {
          field: "purchaseNo",
          headerName: "Purchase No.",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: DebitNoteParams) => (
            <a href={`/purchase/debitnote/${params.row.purchaseid}`}>
            {params.row.billno}
          </a>
          ),
        },
        {
          field: "purchasedate",
          headerName: "Date",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: DebitNoteParams) => DateFormat(params.row.purchasedate),
        },
        {
          field: "total",
          headerName: "Total Amount",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: DebitNoteParams) => params.row.total?.toFixed(decimalPoints),
        },
        {
          field: "createdby",
          headerName: "Created By",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: DebitNoteParams) => params.row.createdby,
        },
        {
          field: "action",
          headerName: "Action",
          width: 200,
          defaultChecked: true,
          sorted: false,
          renderCell: (params: DebitNoteParams) =>
            params.row.branchid === sessionList?.branchId && (
            
              <div className="d-flex">
                <button
                  onClick={() => handlePDFPreviewOfDebitNote(params.row.purchaseid)}
                  style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                >
                  <FaRegFilePdf size={16} />
                </button>
                {params.row.total - params.row.paidamount !== 0 && (
                  <>
                    <button
                       style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                      onClick={() =>
                        (window.location.href = `/purchase/debitnote/${params.row.purchaseid}/edit`)
                      }
                    >
                      <FaRegEdit size={16} />
                    </button>
                    <button
                       style={{ color: "#7a7979", backgroundColor: "transparent", border: "none", cursor: "pointer" }}
                      onClick={() => handleDeleteDebitNote(params.row.purchaseid)}
                    >
                      <RiDeleteBin5Line size={16} />
                    </button>
                  </>
                )}
              </div>
            ),
        },
      ];
      setColumns(debitNoteColumns);
    }
    
  }, [invoiceData]);
  const fetchProductListDatatable = async (startIndex: number, pageLength: number) => {
    setLoadingData(true);
    const res = await axiosFunction(
      `${v2ReactURL}/contact/customdatatable/${params.contactId}/customerspecificprice`,
      "POST",
      {
        searchValue: "",
        length: pageLength,
        start: startIndex,
        draw: 1,
      }
    );
    const validatedData = ProductListDataTableSchema.safeParse(res?.data?.response);
    if (res?.data?.status && validatedData.success) {
      setLoadingData(false);
      const dataList = validatedData.data?.data.map((col: any, index: number) => ({
        ...col,
        index: index + 1,
      }));
      setPaginationInfo(validatedData.data?.dataTableMetaDTO);
      setInvoiceData(dataList);
    } else {
      console.error("API response validation failed:", validatedData.error);
    }
  };
  const handleSaveChanges = async () => {
    const payload = Object.entries(updatedPrice).map(([productId, price]) => ({
      productVarientId: parseInt(productId),
      editPrice: price,
    }));

    if (payload.length>0) {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${params.contactId}/updatecustomerspecificprice`,
      "POST",
      payload
    );

    if (res?.data?.status) {
      toastMessage(res?.data?.response, "success");
      setUpdatedPrice({});
      fetchProductListDatatable(0, 15);
    }
  }
  };



  useEffect(() => {
    fetchInvoiceDatatable(0, 15);
  }, []);

  const handlePageOptions = (customPageSize: number) => {
    fetchInvoiceDatatable(0, customPageSize);
  };

  const handleChangePageOption = (e: SelectChangeEvent<number>, _: React.ReactNode) => {
    const selectedValue = e.target.value;
    setPageOption(selectedValue.toString());
    handlePageOptions(parseInt(selectedValue.toString()));
  };

  const handlePageChange = (_e: React.ChangeEvent<unknown>, page: number) => {
    fetchInvoiceDatatable(
      (page - 1) * parseInt(pageOption),
      parseInt(pageOption)
    );
  };

  const linkFieldNav = (row: GenericDataItemType) => {
    if (row.type === "invoice") {
    return `/sales/invoice/${row.salesid}`;
    } else if (row.type === "pos"){
      return `/pos/${row.salesid}`;
    } else if (row.type === "posreturn") {
      return `/pos/creditnote/${row.salesid}`;
    } else if (row.type === "creditnote") {
      return `/sales/creditnote/${row.salesid}`;
    } else {
      return `#`;

    }
  };
  return (
    <>
      <ContactDetailsDataTableContainer>
      {tabView === "productList" ? (
        <div style={{ display: "flex", margin: "10px" , width : '900px'}}>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span
              style={{ fontWeight: 600, marginBottom: "5px", fontSize: "14px" }}
            >
              Product Details
            </span>
            <div className="productDetailInputMain">
              <ProductSearchTypeHead
                productData={productData}
                fetchProductListDatatable={fetchProductListDatatable}
              />
            </div>
          </div>
          <div>
            <span style={{ fontWeight: 500, visibility: "hidden" }}>btn </span>
            <CustomButton
              className="btn btn-sm pro"
              onClick={handleSaveChanges}
              btnName="Save Changes"
              // disabled={Object.keys(updatedPrice).length === 0}
            />
          </div>
        </div>
      ) : (
        <div style={{ marginTop: "10px", marginLeft: "10px" }}>
          <PageOptions
            pageOption={pageOption}
            handleChangePageOption={handleChangePageOption}
          />
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {tabView === "customerLoyaltyLedger" && (
          <div style={{ marginRight: "10px" }}>
            <span><b>Available Loyalty Points:</b></span>
            <span style={{ color: "rgb(0 154 231)", marginLeft: "5px" }}>
              {loyaltyPoint ? loyaltyPoint?.toFixed(decimalPoints) : 0}
            </span>
          </div>
        )}
      </div>

      <CustomDataTable
        rows={invoiceData}
        columns={columns}
        FixedTable={true}
        // defaultColumns={invoiceColumns}
        paginationInfo={paginationInfo}
        handlePageChange={handlePageChange}
        // handlePageOptions={handlePageOptions}
        handleChangePageOption={handleChangePageOption}
        pageOption={pageOption.toString()}
        loading={loadingData}
        isCheckboxShow={false}
        defaultChecker={() => {
          return true;
        }}
        linkField={"invocicenumber"}
        linkFieldNav={linkFieldNav}
      />
      </ContactDetailsDataTableContainer>
    </>
  );
};

export default ContactDetailsDataTable;
